module.exports = __webpack_public_path__ + "img/moi.7e3a10a8.png";